<app-heading4 [text]="'Select Location'" [isTextBlack]="true"></app-heading4>
<app-heading2 [text]="'Upload your files'" [isTextBlack]="true"></app-heading2>
<input type="file" accept="image/*" #file class="hidden">
<app-button-primary [text]="'From computer'" (click)="file.click()"></app-button-primary>
<app-heading5 [text]="'From product files'" [isTextBlack]="true"></app-heading5>